module.exports = __webpack_public_path__ + "img/icon.0c604f14.png";